import {APIS_ENDPOINTS, tokenKey} from '../../SERVICE-CONSTANTS'
import http from '../../HttpConfig'
import {getItem} from '../../../utils/localstorage'

const apiEndPoint = APIS_ENDPOINTS.supervision

export const request_getcartable = async ({
  search,
  CurrentPage,
  PageSize,
  IsArchive = false,
  type,
  GridType,
  LocationStreet,
  TimeFilter,
  isDabir,
  status,
}: {
  search?: string
  CurrentPage: number
  PageSize: number
  IsArchive: boolean
  type?: number
  GridType?: number
  LocationStreet?: any
  TimeFilter?: string
  isDabir?: boolean
  status?: number
}) => {
  return http.get(
    apiEndPoint.getAll +
      `?CurrentPage=${CurrentPage}&IsArchive=${IsArchive}&PageSize=${PageSize}${
        search ? `&search=${search}` : ''
      }${isDabir !== undefined ? `&IsDabir=${isDabir}` : ''}${type ? `&type=${type}` : ''}${
        TimeFilter ? `&TimeFilter=${TimeFilter}` : ''
      }${GridType ? `&GridType=${GridType}` : ''}${
        LocationStreet ? `&LocationStreet=${LocationStreet}` : ''
      }${status !== undefined ? `&status=${status}` : ''}`
  )
}

export const request_getallrequest = async ({
  search,
  CurrentPage,
  PageSize,
  IsArchive = false,
  type,
  GridType,
  LocationStreet,
  TimeFilter,
  isDabir,
  status,
}: {
  search?: string
  CurrentPage: number
  PageSize: number
  IsArchive: boolean
  type?: number
  GridType?: number
  LocationStreet?: any
  TimeFilter?: string
  isDabir?: boolean
  status?: number
}) => {
  return http.get(
    apiEndPoint.getAllSupervision +
      `?CurrentPage=${CurrentPage}&IsArchive=${IsArchive}&PageSize=${PageSize}${
        search ? `&search=${search}` : ''
      }${isDabir !== undefined ? `&IsDabir=${isDabir}` : ''}${type ? `&type=${type}` : ''}${
        TimeFilter ? `&TimeFilter=${TimeFilter}` : ''
      }${GridType ? `&GridType=${GridType}` : ''}${
        LocationStreet ? `&LocationStreet=${LocationStreet}` : ''
      }${status !== undefined ? `&status=${status}` : ''}`
  )
}


export const request_accept = async (id: number) => {
  return http.put(apiEndPoint.accept + `?Id=${id}`)
}
export const request_getcartablearchivebox = async ({
  search,
  CurrentPage,
  PageSize,
  IsArchive = false,
  type,
  GridType,
  LocationStreet,
  TimeFilter,
}: {
  search?: string
  CurrentPage: number
  PageSize: number
  IsArchive: boolean
  type?: number
  GridType?: number
  LocationStreet?: any
  TimeFilter?: string
}) => {
  return http.get(
    apiEndPoint.getAllArchiveBox +
      `?CurrentPage=${CurrentPage}&IsArchive=${IsArchive}&PageSize=${PageSize}${
        search ? `&search=${search}` : ''
      }${TimeFilter ? `&TimeFilter=${TimeFilter}` : ''}${type ? `&type=${type}` : ''}${
        GridType ? `&GridType=${GridType}` : ''
      }${LocationStreet ? `&LocationStreet=${LocationStreet}` : ''}`
  )
}

export const request_getDetails = async (id: number) => {
  const res = await fetch('https://api.mazfund.ir/api/supervision/getdetail' + `?id=${id}`, {
    headers: {
      Authorization: 'bearer ' + getItem(tokenKey),
    },
  }).then((resp) => resp.json())

  return res
}

export const request_addToCardBoard = async (formData: FormData) => {
  return http.post(apiEndPoint.addtocartable, formData)
}
export const request_addSupervisionRequest = async (formData: FormData) => {
  return http.post(apiEndPoint.addsupervisionrequest, formData)
}
export const request_sendreferencetouser = async (formData: FormData) => {
  return http.post(apiEndPoint.sendreferencetouser, formData)
}
export const request_addFootNote = async (formData: FormData) => {
  return http.post(apiEndPoint.addFootNote, formData)
}

export const request_changearchivecardboard = async ({id, archiveDescription}) => {
  return http.post(
    apiEndPoint.changearchivecardboard +
      '?Id=' +
      id +
      '&ArchiveDescription=' +
      archiveDescription
  )
}

export const request_complete = async (data: any) => {
  return http.put(apiEndPoint.completeRequest, data)
}

export const request_getallwaitinglist = async ({
  search,
  CurrentPage,
  PageSize,
  IsArchive = false,
  type,
  GridType,
  LocationStreet,
  TimeFilter,
}: {
  search?: string
  CurrentPage: number
  PageSize: number
  IsArchive: boolean
  type?: number
  GridType?: number
  LocationStreet?: any
  TimeFilter?: string
}) => {
  return http.get(
    apiEndPoint.getallwaitinglist +
      `?CurrentPage=${CurrentPage}&IsArchive=${IsArchive}&PageSize=${PageSize}${
        search ? `&search=${search}` : ''
      }${type ? `&type=${type}` : ''}${TimeFilter ? `&TimeFilter=${TimeFilter}` : ''}${
        GridType ? `&GridType=${GridType}` : ''
      }${LocationStreet ? `&LocationStreet=${LocationStreet}` : ''}`
  )
}

export const request_getallRequest = async ({
  search,
  CurrentPage,
  PageSize,
  GridType,
  TimeFilter,
}: {
  search?: string
  CurrentPage: number
  PageSize: number
  GridType?: number
  TimeFilter?: string
}) => {
  return http.post(
    apiEndPoint.getAllRequest +
      `?CurrentPage=${CurrentPage}&PageSize=${PageSize}${search ? `&search=${search}` : ''}${
        TimeFilter ? `&TimeFilter=${TimeFilter}` : ''
      }${GridType ? `&GridType=${GridType}` : ''}`
  )
}
export const request_waitingRequest = async ({
  id,
  waitingListDescription = '',
  responseTime = '',
}: {
  id: number
  waitingListDescription: string
  responseTime?: string
}) => {
  return http.post(
    apiEndPoint.waitingRequest +
      '?Id=' +
      id +
      '&WaitingListDescription=' +
      waitingListDescription +
      '&responseTime=' +
      responseTime || ''
  )
}

export const request_changewaitinglistresponsetimecardboard = async ({
  id,
  responseTime,
}: {
  id?: number
  responseTime?: string
}) => {
  return http.post(
    apiEndPoint.changewaitinglistresponsetimecardboard +
      `?Id=${id}&ResponseTime=${responseTime}`
  )
}

export const request_getmenucount = async () => {
  return http.get(apiEndPoint.getmenucount)
}

export const request_getallcardboard72h = async () => {
  return http.get(apiEndPoint.getallcardboard72h)
}

export const request_getallfootnote = async (RequestId?: number) => {
  return http.get(apiEndPoint.getallfootnote + '?RequestId=' + RequestId)
}

export const request_addfile = async (formData: FormData) => {
  return http.put(apiEndPoint.addfile, formData)
}

export const request_getallrequestfile = async (RequestId: number) => {
  return http.get(apiEndPoint.getallrequestfile + '?SupervisionId=' + RequestId)
}
export const request_changerequeststep = async ({
  step1,
  step2,
  step3,
  step4,
  step5,
  step6,
  RequestId,
}: {
  step1: boolean
  step2: boolean
  step3: boolean
  step4: boolean
  step5: boolean
  step6: boolean
  RequestId: number
}) => {
  const params = {
    Step1: step1,
    Step2: step2,
    Step3: step3,
    Step4: step4,
    Step5: step5,
    Step6: step6,
    RequestId: RequestId,
  };

  return http.put(apiEndPoint.upsertrequeststep, params);
}


export const request_rejectrequest = async ({
  id,
  text,
  otherFilesInputRef,
}: {
  id: number
  text: string
  otherFilesInputRef: any[]
}) => {
  const formData = new FormData()
  formData.append('Id', id.toString())
  formData.append('Text', text)
  const files = otherFilesInputRef ?? []
  for (let i = 0; i < files.length; i++) {
    formData.append('IFile', files[i])
  }
  return http.post(apiEndPoint.rejectrequest, formData)
}